import React from 'react';
import './Impressum.css';

const ImpressumDe = () => {
  return (
    <div className="impressum-page">
      <div className="container">
        <h1 className="impressum-title">Impressum</h1>

        <section className="impressum-section">
          <h2>Unternehmen</h2>
          <p>
            <strong>Vegbox GmbH</strong><br />
            <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>
          </p>
        </section>

        <section className="impressum-section">
          <h2>Handelsregistereintrag</h2>
          <table className="impressum-table">
            <tbody>
              <tr>
                <td><strong>UID</strong></td>
                <td>CHE-208.771.757</td>
              </tr>
              <tr>
                <td><strong>CH-ID</strong></td>
                <td>CH-020-4072416-7</td>
              </tr>
              <tr>
                <td><strong>MWST-Nummer</strong></td>
                <td>CHE-208.771.757 MWST</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section className="impressum-section">
          <h2>Gründer</h2>
          <p>(Ario) Saeid Vaghefi</p>
        </section>
      </div>
    </div>
  );
};

export default ImpressumDe;
